import {
  FamilienstandAuswahlElement,
  FamilienstandAuswahlTextKeys,
} from '@ps20-frontend/frontend-models';
import { FamilienStand } from '@ps20/bff-models';
import { IAppState } from '../../../store/appState';
import { VersObjekt } from '../../../store/reducers/versObjekt.reducer';
import {
  StaendigBewohntElement,
  StaendigBewohntEnum,
  StaendigBewohntEnumTextKeys,
} from '../../../store/model/versObjekt.model';

export const selectVersObjekt = (state: IAppState): VersObjekt => state.versObjekt;

export const selectGebaeudeStaendigBewohnt = (state: IAppState): string => {
  if (state.versObjekt.gebaeudeStaendigBewohnt === null) {
    return null;
  } else if (state.versObjekt.gebaeudeStaendigBewohnt === true) {
    return 'ja';
  } else {
    return 'nein';
  }
};

export const selectGebaeudeInnerhalbWohngebiet = (state: IAppState): string => {
  if (state.versObjekt.gebaeudeInnerhalbWohngebiet === null) {
    return null;
  } else if (state.versObjekt.gebaeudeInnerhalbWohngebiet === true) {
    return 'ja';
  } else {
    return 'nein';
  }
};

function convertStaendigBewohntEnumToTextKey(
  staendigBewohntEnum: StaendigBewohntEnum,
): StaendigBewohntEnumTextKeys {
  return {
    [StaendigBewohntEnum.STAENDIG_BEWOHNT]: StaendigBewohntEnumTextKeys.STAENDIG_BEWOHNT,
    [StaendigBewohntEnum.NICHT_STAENDIG_BEWOHNT]:
      StaendigBewohntEnumTextKeys.NICHT_STAENDIG_BEWOHNT,
  }[staendigBewohntEnum];
}

function getStaendigBewohntElemente(): StaendigBewohntElement[] {
  const staendigBewohntElememte: StaendigBewohntEnum[] = Object.values(StaendigBewohntEnum);
  return staendigBewohntElememte.map(staendigBewohntElememt => ({
    textKey: convertStaendigBewohntEnumToTextKey(staendigBewohntElememt),
    value: staendigBewohntElememt,
  }));
}

export const selectStaendigBewohnt = (state: IAppState): StaendigBewohntEnum => {
  switch (state.versObjekt.staendigBewohnt) {
    case true:
      return StaendigBewohntEnum.STAENDIG_BEWOHNT;
    case false:
      return StaendigBewohntEnum.NICHT_STAENDIG_BEWOHNT;
    default:
      return null;
  }
};

export const selectStaendigBewohntBoolean = (state: IAppState): boolean => {
  return state.versObjekt?.staendigBewohnt;
};

export const selectStaendigBewohntAuswahlElemente = (): StaendigBewohntElement[] => {
  return getStaendigBewohntElemente();
};

export type SelectStaendigBewohntReturnType = ReturnType<typeof selectStaendigBewohnt>;
export type SelectStaendigBewohntAuswahlElementeReturnType = ReturnType<
  typeof selectStaendigBewohntAuswahlElemente
>;

export const selectFamilienstand = (state: IAppState): FamilienStand => {
  return state.versicherungsnehmer.familienstand;
};

export const selectFamilienstandAuswahlElemente = (): FamilienstandAuswahlElement[] => {
  return getFamilienstandAuswahlElemente();
};

function convertFamilienstandToTextKey(familienstand: FamilienStand): FamilienstandAuswahlTextKeys {
  return {
    [FamilienStand.SINGLE]: FamilienstandAuswahlTextKeys.LEDIG,
    [FamilienStand.PARTNER]: FamilienstandAuswahlTextKeys.PARTNER,
    [FamilienStand.KIND]: FamilienstandAuswahlTextKeys.KINDER,
    [FamilienStand.FAMILIE]: FamilienstandAuswahlTextKeys.PARTNER_UND_KINDER,
  }[familienstand];
}

function getFamilienstandAuswahlElemente(): FamilienstandAuswahlElement[] {
  const familienstaende = Object.values(FamilienStand);
  return familienstaende.map(familienstand => ({
    textKey: convertFamilienstandToTextKey(familienstand),
    value: familienstand,
  }));
}

export type SelectFamilienstandReturnType = ReturnType<typeof selectFamilienstand>;
export type SelectFamilienstandAuswahlElementeReturnType = ReturnType<
  typeof selectFamilienstandAuswahlElemente
>;
